module.exports = __webpack_public_path__ + "static/media/cezep_payrollTicket_pattern_EN_50.1f352e30.jpg";